import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSite } from '../hooks/useSite';
import { PAGE, cleanPath } from '../lib/content';
import { ActionLink } from './Primitives';
import Header from './Header';
import Footer from './Footer';

function ScrollRestoration() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    const id = window.setTimeout(() => document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({ block: 'start' }), 250);
    return () => window.clearTimeout(id);
  }, [pathname, hash]);
  return null;
}

function StickyMobileAction() {
  const { pathname } = useLocation();
  const { pathFor, settings } = useSite();
  const education = cleanPath(pathFor(PAGE.education));
  const services = [PAGE.treatments, PAGE.grooming, PAGE.osteopathy, PAGE.massage, PAGE.craniosacral].map((key) => cleanPath(pathFor(key)));
  const target = cleanPath(pathname);
  let to = '';
  let label = '';
  if (target === education && pathFor(PAGE.education)) { to = pathFor(PAGE.talk); label = 'Book samtale'; }
  else if (services.includes(target) && pathFor(PAGE.treatments)) { to = settings?.booking_url || ''; label = 'Book tid'; }
  if (!to) return null;
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-ink/15 bg-paper/98 px-4 pt-3 pb-[max(12px,env(safe-area-inset-bottom))] shadow-[0_-8px_35px_rgba(19,23,54,.1)] min-[1200px]:hidden"><ActionLink to={to} className="w-full">{label}</ActionLink></div>;
}

export default function SiteShell({ children }) {
  const { pathname } = useLocation();
  const { pathFor } = useSite();
  const pathsWithSticky = [PAGE.education, PAGE.treatments, PAGE.grooming, PAGE.osteopathy, PAGE.massage, PAGE.craniosacral].map((key) => pathFor(key)).filter(Boolean).map(cleanPath);
  const sticky = pathsWithSticky.includes(cleanPath(pathname));
  return <div className="flex min-h-screen flex-col overflow-x-clip"><a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-[90] focus:bg-white focus:p-3 focus:text-ink">Spring til indhold</a><ScrollRestoration /><Header /><main id="main" className="flex-1">{children}</main><div className={sticky ? 'bg-ink-dark pb-[86px] min-[1200px]:pb-0' : ''}><Footer /></div><StickyMobileAction /></div>;
}
